import styled from "styled-components";
import { Underlinelink, InputWrapper, InputWrapperDrop, PillButtonAdd } from "../../../../../NPA/Pages/Step1Setup/styles";
import {Err} from "../../../../../NPA/Pages/Step1Setup/styles";


export const UnderlinelinkSpace = styled(Underlinelink)`
    margin-left: 30px;
    line-height: 40px;
    vertical-align: middle;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin: 16px 0 20px 4%;
    }
`

export const InputWrapperWrap = styled(InputWrapper)`
    margin-bottom: -4px;
`

export const InputWrapperDropWrap = styled(InputWrapperDrop)`
    margin-bottom: 0px;
`

export const PillButtonAddSpace = styled(PillButtonAdd)`
    margin-bottom: 50px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0;
    margin-bottom: 40px;
  }
`

export const ErrMargin = styled(Err)`
  margin-top: 8px;
`

export const ErrRelation = styled(Err)`
  margin-top: -1px;
`

export const MainWrap = styled.div`
  margin-bottom: 16px;
`

export const ButtonMargin = styled.div`
  margin-top: 0px;
`

export const DividerWrap = styled.div`
  .ant-divider {
    background: #d4d4d4;
  }
`
export const ButtonDivider = styled.div`
  .ant-divider {
    background: #d4d4d4;
    height: 1px;
    margin-top: 20px;
    @media only screen and (min-width > 320px) and (max-width < 767px) {
    height:1px;
    margin-top:40px;
    }
  }
`
export const RelatedContributorMargin = styled.div`
.ant-form-item{
margin-bottom: ${props => (props)? props.marginBottom : "20px"}
}
`